<template>
  <div class="send-voice">
    <van-nav-bar title="短消息" :fixed="true" left-text="返回" :border="false" left-arrow @click-left="backPage" />
    <div class="voice-tarea">
      <van-field
        v-model="message"
        rows="4"
        autosize
        type="textarea"
        maxlength="200"
        placeholder="请输入短消息内容"
        show-word-limit
      />
    </div>
    <!-- <div class="more-box">
      <div class="more-flex">
        <span class="more-span">播报方式</span>
        <p class="more-surplus no-arrows">{{voiceType}}</p>
      </div>
      <div class="more-flex" @click="openOption('num')">
        <span class="more-span">播报次数</span>
        <p class="more-surplus">{{voiceNum?voiceNum:'请选择'}}</p>
        <div class="arrows"></div>
      </div>
      <div class="more-flex" @click="openOption('flicker')">
        <span class="more-span">是否闪烁屏幕或LED</span>
        <p class="more-surplus">{{voiceFlicker?voiceFlicker:'请选择'}}</p>
        <div class="arrows"></div>
      </div>
    </div> -->
    <div class="btn-box">
      <van-button round type="info" @click="save">发送</van-button>
    </div>
    <van-popup :show="show" position="bottom" closeable round @close="onClose">
      <div class="pop-content">
          <span class="device-title">{{title}}</span>
          <div class="auto-box">
              <div class="device-information" v-for="(item,index) in checkList" :key="index" @click="checkThat(item)">
                <p>{{item.lable}}</p>
              </div>
          </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data () {
    return {
      message:'',
      voiceType:'震动',
      show:false,
      checkList:[],
      voiceNum:'1次',
      voiceFlicker:'是',
      title:''
    }
  },
  components: {
  
  },

  methods: {
    /**
     * 返回上一级
     */
    backPage() {
        this.$router.back(-1);
    },
    openOption(val){
      if(val==='num'){
        this.title = "播报次数"
        this.checkList = [
          {
            lable:'1次',
            value:'1'
          },
          {
            lable:'2次',
            value:'2'
          },
          {
            lable:'3次',
            value:'3'
          }
        ]
      }else if(val==='flicker'){
        this.title = "是否闪烁屏幕或LED"
        this.checkList = [
          {
            lable:'是',
            value:'1'
          },
          {
            lable:'否',
            value:'0'
          }
        ]
      }
      this.show = true;
    },
    //选中
    checkThat(item){
      if(this.title == "播报次数"){
        this.voiceNum = item.lable
      }else if(this.title == "是否闪烁屏幕或LED"){
        this.voiceFlicker = item.lable
      }
      this.show = false;
    },
    //关闭弹窗
    onClose(){
      this.show = false;
    },
    save(){
      let obj = {
        '1次':'1',
        '2次':'2',
        '3次':'3',
      },flickerObj={
        '是':'1',
        '否':'0'
      };
      let data = {
        ver:1,
        method:'sendShortMessage',
        flashScreenOrLED:'0',
        frequency:'1',
        instructionId:this.$intfilter.instructFilter('短消息'),
        imei:this.imei,
        // frequency:obj[this.voiceNum],
        // flashScreenOrLED:flickerObj[this.voiceFlicker],
        content:this.message
      }
      this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
          if (res.code === 0) {
            this.message = "";
            this.$toast({
              title: "发送成功",
              icon: "success"
            });
            this.$router.back(-1);
          }else{
            this.$toast({
              message: res.msg,
              duration: 2000,
              icon: require('@/assets/images/safety-fence/wrong.png'),
            });
          }
      })
    }
  },
  watch:{
  },
  created () {
  },
}
</script>

<style scoped>
.send-voice{
  min-height: 100vh;
  background-color: #f8f8f8;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.voice-tarea{
  width: 100%;
  margin-top: 130px;
  border-radius: 15px;
  overflow: hidden;
}
.pop-content{
  background-color: #fff;
  position: relative;
}
.pop-content .device-title{
  position: absolute;
  background-color: #fff;
  width: 100%;
  text-align: center;
  top: 0;
  font-size: 34px;
  font-weight: 600;
  color: #111;
  display: flex;
  justify-content: center;
  padding: 20px 0 30px 0;
}
.auto-box{
  height: 250px;
  overflow: auto;
  padding-top: 130px;
}
.no-data-center{
  line-height: 250px;
  text-align: center;
}
.pop-content  .device-information{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
}
.more-box{
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 20px;
  margin-top: 25px;
}
.more-flex{
  display: flex;
  align-items: center;
  width: 670px;
  height: 101px;
  border-radius: 15px;
  background-color: #fff;
}
.more-span{
  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #666;
  margin-left: 32px;
}
.more-surplus{
  text-align: right;
  flex: 1;
  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}
.no-arrows{
  margin-right: 36px;
}
.arrows{
  width: 15px;
  height: 15px;
  transform:rotate(45deg);
  border-top: 3px solid #999;
  border-right: 3px solid #999;
  margin: 0 36px 0 20px;
}
.btn-box{
  z-index: 1;
  position: fixed;
  width: 100%;
  padding: 20px 0 50px;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f8f8;
}
</style>
<style>
.send-voice .van-field__control{
  width: 100%;
  min-height: 600px;
  max-height: 600px;
  overflow-y: scroll;
  border-radius: 15px;
  background-color: #fff;
}
.send-voice .van-field__control::-webkit-scrollbar {
  display:none
}
.send-voice .btn-box .van-button{
  margin: 0 auto;
  border: none;
  width: 586px;
  height: 98px;
  background: #01ADA9;
  color: #fff;
  border: 2px solid #01ADA9; 
}
</style>
